import { render, staticRenderFns } from "./refundsDetailForWXMall.vue?vue&type=template&id=48ff30ee"
import script from "./refundsDetailForWXMall.vue?vue&type=script&lang=js"
export * from "./refundsDetailForWXMall.vue?vue&type=script&lang=js"
import style0 from "./refundsDetailForWXMall.vue?vue&type=style&index=0&id=48ff30ee&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports